import * as React from "react";
import * as Tools from "../../helpers/Tools";
import { logUI } from "../../api/andyliticsApi";
import MyChartContainer from "./MyChartContainer";

const Audit = () => {
    logUI("MBHWeb.UI.Audit.ComponentDidMount", new Date(), Tools.getURLPath());
    return <MyChartContainer mode="audit" title="Who's Accessed My Record" />;
};

export default Audit;